import Vue from 'vue'
import Vuex from 'vuex'
import rootState from './state'
import rootGetters from './getters'
import rootMutations from './mutations'
import rootActions from './actions'
import meterReadingModule from './modules/meterReading'
import consumptionModule from './modules/consumption'
import appointmentModule from './modules/appointment'
import unsubscribeModule from './modules/unsubscribe'
import monthOfStatement from './modules/monthOfStatement'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  state: rootState,
  getters: rootGetters,
  mutations: rootMutations,
  actions: rootActions,
  modules: {
    meterReading: meterReadingModule,
    consumption: consumptionModule,
    appointment: appointmentModule,
    unsubscribe: unsubscribeModule,
    monthOfStatement: monthOfStatement
  },
  strict: debug
})
